import utils from "./utils";


const getCustomExtensionParameter = (key,userFromService) => {
  try {
    const parameter = userFromService.businessPartner.customExtension.parameters.find(p => p.key === key);
    return parameter ? parameter.value : null;
  } catch (e) {
    return null;
  }
};

const checkEmails = (newEmails, originalEmails, mailToReturn)=>{

  for (const email of newEmails) {
    if( !email.consGUID || utils.thereAreDeepDifferences(email, originalEmails.find( m => m.consGUID===email.consGUID ) ) ){
      mailToReturn.push(email);
    }
  }
  return mailToReturn;
}

const checkPhones = (newPhones, originalPhones, phoneToReturn)=>{
  for (const phone of newPhones) {
    if( !phone.consGUID || utils.thereAreDeepDifferences(phone, originalPhones.find( m => m.consGUID===phone.consGUID ) ) ){
      phoneToReturn.push(phone);
    }
  }
  return phoneToReturn;
}

const prepareNewCommunications = (toReturn, mailToReturn, phoneToReturn)=>{
  if(mailToReturn.length){
    toReturn['communicationEMails'] = mailToReturn;
  }
  if(phoneToReturn.length){
    toReturn['communicationPhones'] = phoneToReturn;
  }
  return toReturn;
}

const getNewCommunications = (originalUser, normalizedUser) =>{
  let toReturn: any = {};
  let mailToReturn: any = [];
  let phoneToReturn: any = [];
  const originalEmails = originalUser.communications && originalUser.communications.communicationEMails ? originalUser.communications.communicationEMails : [];
  const newEmails = normalizedUser.communications && normalizedUser.communications.communicationEMails ? normalizedUser.communications.communicationEMails : [];
  const originalPhones = originalUser.communications && originalUser.communications.communicationPhones ? originalUser.communications.communicationPhones : [];
  const newPhones = normalizedUser.communications && normalizedUser.communications.communicationPhones ? normalizedUser.communications.communicationPhones : [];
  mailToReturn = checkEmails(newEmails, originalEmails, mailToReturn)
  phoneToReturn = checkPhones(newPhones, originalPhones, phoneToReturn)
  toReturn = prepareNewCommunications(toReturn, mailToReturn, phoneToReturn)
  return toReturn;
}

const getNewAddresses = (originalUser, normalizedUser) =>{
  if(originalUser.addresses){
    const toReturn: any = [];
    for (const address of normalizedUser.addresses) {
      if( !address.addressGUID || utils.thereAreDeepDifferences(address, originalUser.addresses.find( a => a.addressGUID===address.addressGUID ) ) ){
        toReturn.push(address);
      }
    }
    return {addresses:toReturn};
  }else{
    return {addresses:normalizedUser.addresses};
  }
}

const getNewDealers = (originalUser, normalizedUser) =>{
  if(originalUser.dealers){
    const toReturn: any = [];
    for (const dealer of normalizedUser.dealers) {
      if( !dealer.dealerGUID || utils.thereAreDeepDifferences(dealer, originalUser.dealers.find( d => d.dealerGUID===dealer.dealerGUID ) ) ){
        toReturn.push(dealer);
      }
    }
    return {dealers:toReturn};
  }else{
    return {dealers:normalizedUser.dealers};
  }
}

const setCustomExtensionParameter = function (key, normalizedUser) {
  const value = normalizedUser[key];
  if (value === null) return;
  if (!normalizedUser.customExtension) normalizedUser['customExtension'] = {};
  if (!normalizedUser.customExtension.parameters) normalizedUser.customExtension['parameters'] = [];
  const parameter = normalizedUser.customExtension.parameters.find(p => p.key === key);
  if (parameter) parameter.value = value;
  else normalizedUser.customExtension.parameters.push({key, value});
};

/**
 * Normalize the user object form service in order to retrive only the information needed
 * @param userFromService
 */
const normalizeUser = function (userFromService, userSaved, currentCountry) {
  const businessPartner = userFromService.businessPartner || {};
  const contactPolicyConsents = userFromService.contactPolicyConsents;
  const alternateFirstName = getCustomExtensionParameter('alternateFirstName',userFromService);
  const alternateLastName = getCustomExtensionParameter('alternateLastName',userFromService);
  const addresses = businessPartner.addresses ? businessPartner.addresses.addresses : undefined;
  const vehicles = businessPartner.vehicles ? businessPartner.vehicles.vehicles : undefined;
  const dealers = businessPartner.dealers ? businessPartner.dealers.dealers : undefined;
  const birthAddress = businessPartner.birthAddress ? businessPartner.birthAddress : undefined;
  return  {
    gcid: userFromService.gcid,
    ucid: userFromService.ucid,
    firstName: businessPartner.givenName, 
    lastName: businessPartner.surname,
    nickname: businessPartner.nickname,
    initialsName: businessPartner.initialsName,
    title: businessPartner.title,
    salutation: businessPartner.salutation,
    gender: businessPartner.gender,
    birthday: businessPartner.birthday,
    additionalFamilyName: businessPartner.additionalFamilyName,
    alternateFirstName,
    alternateLastName,
    communications: businessPartner.communications,
    correspondLanguageISO: businessPartner.correspondLanguageISO,
    homeMarket: businessPartner.homeMarket,
    addresses,
    vehicles,
    dealers,
    birthPlace: birthAddress?.city || undefined,
    nationalityISO: businessPartner.nationalityISO,
    partnerCategory: businessPartner.partnerCategory,
    contactPolicyConsents,
    email: userFromService.userAccount ? userFromService.userAccount.mail : userSaved.email,
    linkedAccounts: userFromService.userAccount ? userFromService.userAccount.linkedAccounts : userSaved.linkedAccounts
  };

};
const prepareNormalizedBirthday = (normalizedUser,serviceUser,originalUser)=>{
  if(normalizedUser.birthday!=originalUser.birthday){
    if(normalizedUser.birthday){
      serviceUser.businessPartner['birthday'] = normalizedUser.birthday;
    }else{
      //to delete birthday
      serviceUser.businessPartner['birthday'] = undefined;
      serviceUser.businessPartner['birthdayDelete'] = true;
    }
  }
  return serviceUser;
};

const prepareNormalizedUser = (serviceUser,normalizedUser,originalUser)=>{
  if(normalizedUser.firstName!=originalUser.firstName){
    serviceUser.businessPartner['givenName'] = normalizedUser.firstName;
  }
  if(normalizedUser.lastName!=originalUser.lastName){
    serviceUser.businessPartner['surname'] = normalizedUser.lastName;
  }
  if(normalizedUser.nickname!=originalUser.nickname){
    serviceUser.businessPartner['nickname'] = normalizedUser.nickname;
  }
  if(normalizedUser.initialsName!=originalUser.initialsName){
    serviceUser.businessPartner['initialsName'] = normalizedUser.initialsName;
  }
  if(normalizedUser.salutation!=originalUser.salutation){
    serviceUser.businessPartner['salutation'] = normalizedUser.salutation;
  }
  if(normalizedUser.gender!=originalUser.gender){
    serviceUser.businessPartner['gender'] = normalizedUser.gender;
  }
  if(normalizedUser.title!=originalUser.title){
    if(!normalizedUser.title){
      //to delete title
      serviceUser.businessPartner['title'] = "";
    }else{
      serviceUser.businessPartner['title'] = normalizedUser.title;
    }
  }
  if(normalizedUser.additionalFamilyName!=originalUser.additionalFamilyName){
    serviceUser.businessPartner['additionalFamilyName'] = normalizedUser.additionalFamilyName;
  }
  if(normalizedUser.correspondLanguageISO!=originalUser.correspondLanguageISO){
    serviceUser.businessPartner['correspondLanguageISO'] = normalizedUser.correspondLanguageISO;
  }
  if(normalizedUser.homeMarket!=originalUser.homeMarket){
    serviceUser.businessPartner['homeMarket'] = normalizedUser.homeMarket;
  }
  if(normalizedUser.nationalityISO!=originalUser.nationalityISO){
    if(!normalizedUser.nationalityISO){
      //to delete nationalityISO
      serviceUser.businessPartner['nationalityISO'] = "";
    }else{
      serviceUser.businessPartner['nationalityISO'] = normalizedUser.nationalityISO;
    }
  }

  serviceUser = prepareNormalizedBirthday(normalizedUser,serviceUser,originalUser);

  return serviceUser;
}

const parseUserData = function (normalizedUser, originalUser, currentCountry) {
  let serviceUser = {
    businessPartner: {
      gcid: normalizedUser.gcid, //mandatory
      partnerCategory: normalizedUser.partnerCategory,//mandatory
    },


  };
  serviceUser = prepareNormalizedUser(serviceUser,normalizedUser,originalUser)
  
  if(normalizedUser.alternateFirstName != originalUser.alternateFirstName){
    setCustomExtensionParameter('alternateFirstName', normalizedUser);
    serviceUser.businessPartner['customExtension']=normalizedUser.customExtension
  }
  if(normalizedUser.alternateLastName != originalUser.alternateLastName){
    setCustomExtensionParameter('alternateLastName', normalizedUser);
    serviceUser.businessPartner['customExtension']=normalizedUser.customExtension
  }
  if(utils.thereAreDeepDifferences(normalizedUser.communications, originalUser.communications)){
    serviceUser.businessPartner['communications'] = getNewCommunications(originalUser,normalizedUser);
  }
  if(
      (
        originalUser.addresses && 
        utils.thereAreDeepDifferences(normalizedUser.addresses, originalUser.addresses)
      ) ||
      (!originalUser.addresses && normalizedUser.addresses)
    ){
    serviceUser.businessPartner['addresses'] = {addresses: normalizedUser.addresses} //getNewAddresses(originalUser, normalizedUser);
  }
  if(
    (
      originalUser.dealers &&
      utils.thereAreDeepDifferences(normalizedUser.dealers, originalUser.dealers)
    ) || 
    (!originalUser.dealers && normalizedUser.dealers)
  ) {
    serviceUser.businessPartner['dealers'] = getNewDealers(originalUser, normalizedUser);
  }
  if(
    (
      originalUser.birthPlace &&
      normalizedUser.birthPlace!=originalUser.birthPlace
    ) || 
    (!originalUser.birthPlace && normalizedUser.birthPlace)
  ) {
    if(!serviceUser.businessPartner['birthAddress']) {
      serviceUser.businessPartner['birthAddress'] = {};
    }

    serviceUser.businessPartner['birthAddress'].city = normalizedUser.birthPlace;
    serviceUser.businessPartner['birthAddress'].addressStatus = 'PRIVATE';
  }
  return serviceUser;
};



export default {
  
  normalizeUser,

  parseUserData,
  
};
